<template>
    <div id="DetailBimbingan">
        <div class="r-header r-center-flex">
            <h1>
                Detail Bimbingan
            </h1>
            <div class="r-center-flex"
                style="margin-left: 10px; margin-right: auto;"
            >
                <p style="margin-right: 10px;">Jenis Bimbingan</p>
                <p class="y-alert" :class="data.type == 'offline' ? 'y-alert-warning' : 'y-alert-success'">{{data.type}}</p>
            </div>
        </div>
        <div class="r-body">
            <div class="r-alert r-center-flex"
                :class="data.status == 0 ? 'y-alert-warning' : 'y-alert-primary'"
            >
                <img :src="require(`@/assets/icons/others/${data.status == 0 ? 'circle-attention' : 'circle-success'}.svg`)" alt="">
                <span v-if="data.status == 0">Bimbingan anda belum dikonfirmasi</span>
                <span v-if="data.status == 1 && role != 'mahasiswa'">Terima kasih telah mengonfirmasi bimbingan ini</span>
                <span v-if="data.status == 1 && role == 'mahasiswa'">Bimbingan telah dikonfirmasi</span>
            </div>
            <div class="r-guidance-area">
                <div class="r-guidance-body r-chat">
                    <div class="r-guidance-chat" 
                        v-for="msg in data.messages" 
                        :key="`chat-${msg.id}`"
                    >
                        <div class="r-sender r-center-flex" 
                            :style="userId != msg.sender_id ? '' : 'flex-direction: row-reverse'"
                        >
                            <div class="r-sender-initial">
                                <div class="r-initialRounded" 
                                    :class="userId != msg.sender_id ? 'y-blue-bg' : 'y-orange-bg'"
                                >
                                    {{inisial(msg.sender)}}
                                </div>
                            </div>
                            <div class="r-sender-detail" >
                                <p class="r-chat-title">{{msg.sender}}</p>
                                <p class="r-chat-time">{{convertDateTime(msg.created_at)}}</p>
                            </div>
                        </div>
                        <div class="r-chat-box y-black-text" 
                            :class="userId != msg.sender_id ? 'r-chat-boxtype1 y-lightgray2-bg' : 'r-chat-boxtype2 y-blue-bg y-white-text'"
                        >
                            <div v-html="msg.message"></div>
                        </div>
                    </div>
                    <div class="r-guidance-tiptap" v-show="data.status == 0">
                        <div class="r-header-tiptap r-center-flex">
                            Pesan Anda
                        </div>
                        <div class="r-attributes-tiptap r-center-flex">
                            <editor-menu-bar :editor="editor"
                                v-slot="{ commands, isActive }"
                            >
                                <div class="tiptap r-center-flex">
                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.bold() }"
                                        @click="commands.bold"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/bold.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.italic() }"
                                        @click="commands.italic"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/italic.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.strike() }"
                                        @click="commands.strike"
                                    >
                                        <strike>S</strike>
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.underline() }"
                                        @click="commands.strike"
                                    >
                                        <u>U</u>
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.ordered_list() }"
                                        @click="commands.ordered_list"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/list.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        :class="{ 'is-active' : isActive.blockquote() }"
                                        @click="commands.blockquote"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/list.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        @click="commands.undo"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/undo.svg')">
                                    </button>

                                    <button class="tiptap_button"
                                        @click="commands.redo"
                                    >
                                        <img :src="require('@/assets/icons/tiptap/redo.svg')">
                                    </button>
                                </div>
                            </editor-menu-bar>
                        </div>
                        <div class="r-input-titap y-inputField r-isRelative">
                            <editor-menu-bubble
                                class="menububble" 
                                :editor="editor" 
                                @hide="hideLinkMenu" 
                                v-slot="{ commands, isActive, getMarkAttrs, menu }"
                            >
                                <div
                                    class="menububble"
                                    :class="{ 'is-active': menu.isActive }"
                                    :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
                                >
                                    <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
                                        <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                                        <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
                                            <img :src="require('@/assets/icons/others/close-outline-white.svg')" alt="">
                                        </button>
                                    </form>
                                    <template v-else>
                                        <button
                                            class="menububble__button"
                                            @click="showLinkMenu(getMarkAttrs('link'))"
                                            :class="{ 'is-active': isActive.link() }"
                                        >
                                            <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
                                        </button>
                                    </template>
                                </div>
                            </editor-menu-bubble>
                            <editor-content class="editor__content" :editor="editor"/>
                            <div class="y-errorText y-red-text" :style="errorData ? 'opacity: 1 !important;': ''">
                                {{errorMsg}}
                            </div>
                        </div>
                        <div class="r-guidance-button r-center-flex">
                            <button class="y-secondary-btn y-sm-size y-hasspace-btn is-fullonmobile" style="margin-left: auto" @click.prevent="backToGuidance()">
                                Kembali
                            </button>
                            <button class="y-primary-btn y-hasspace-btn y-sm-size is-fullonmobile" @click.prevent="modal = true">
                                    <span v-if="!loading">Kirim</span>
                                    <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-else />   
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="r-modal" v-if="modal">
            <div class="r-box"> 
                <div class="r-header">
                    <h1>Pesan Anda</h1>
                </div>
                <div class="r-body">
                    <div v-html="editor.getHTML()"></div>
                </div>
                <div class="r-footer r-center-flex" style="flex-wrap: wrap">
                    <ButtonCustom :disabled="loading" class="y-hasspace-btn y-sm-size is-fullonmobile" style="margin-left: auto" @click.prevent="modal = false">
                        Batal
                    </ButtonCustom>
                    <ButtonCustom :disabled="loading" class="y-danger-btn y-hasspace-btn y-sm-size is-fullonmobile"  @click.prevent="storeData(1); inputType = 'approved'" v-if="role != 'mahasiswa'">
                        <span v-if="!loading || inputType != 'approved'">Kirim & Akhiri</span>
                        <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-else />   
                    </ButtonCustom>
                    <ButtonCustom :disabled="loading" class="y-primary-btn y-hasspace-btn y-sm-size is-fullonmobile"  @click.prevent="storeData()">
                        <span v-if="!loading">Kirim</span>
                        <img :src="require('@/assets/loadingDot.svg')" alt style="width: 50px;" v-else />   
                    </ButtonCustom>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    convertDateTime,
} from '@/common/timeformat'
import {
    Blockquote,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image,
    Placeholder
} from 'tiptap-extensions'
import tableMethods from '@/mixins/tableMethods'
import common from '@/mixins/function/common'
import link from '@/mixins/link'
import { mapActions, mapGetters } from "vuex";
export default {
    mixins: [tableMethods, common, link],
    components: {
        EditorContent,
        EditorMenuBar,
    },
    mounted() {
        this.setActiveTab("Tapi")
        const breadcrumb = [
            {
                name: 'Bimbingan Tapi',
                link: {name: 'ListUserBimbingan', query: {...this.$route.query}},
                current: false
            },
            {
                name: 'List Bimbingan',
                link: {name: 'ListBimbingan', params: {tapi_lecture_id: this.$route.params.tapi_lecture_id}, query: {...this.$route.query}},
                current: false
            },
            {
                name: 'Form Bimbingan',
                link: {name: null},
                current: true
            }
        ]
        this.setBreadCrumb(breadcrumb)
        this.getData()
    },
    data: () => ({
        editor: new Editor({
            extensions: [
            new Image(),
            new History(),
            new Blockquote(),
            new BulletList(),
            new HardBreak(),
            new Heading({ levels: [1, 2, 3] }),
            new HorizontalRule(),
            new ListItem(),
            new OrderedList(),
            new TodoItem(),
            new TodoList(),
            new Link(),
            new Bold(),
            new Italic(),
            new Strike(),
            new Underline(),
            new Placeholder({
                emptyEditorClass: 'is-editor-empty',
                emptyNodeClass: 'is-empty',
                emptyNodeText: 'Ceritakan Masalah Anda Disini . . .',
                showOnlyWhenEditable: true,
                showOnlyCurrent: true,
            }),
            ],
        }),
        errorData: false,
        errorMsg: 'Tidak boleh kosong',
        loading: false,
        modal:false,
        dropdown: false,
        typeDropdown: false,
        inputType: 'Kirim',
    }),
    beforeDestroy() {
        this.editor.destroy()
    },
    computed: {
        ...mapGetters ({
            data: 'tapiGuidance/getGuidance',
            role: 'auth/getRole',
            userId: 'auth/getId',
            item: 'tapiGuidance/getItem'
        }),
    },
    methods: {
        ...mapActions ({
            getGuidanceById: 'tapiGuidance/getGuidanceData',
            store: 'tapiGuidance/update'
        }),
        convertDateTime(value){
            return convertDateTime(value);
        },
        inisial(text) {
            var temp = text.split(" ");
            var inisial = "";
            for (var i = 0; i < temp.length; i++){
                if(i > 1){
                    break
                }
                inisial += temp[i][0];
            }
            return inisial;
        },
        backToGuidance(){
            this.$router.push({name: 'ListBimbingan', params: {tapi_lecture_id: this.$route.params.tapi_lecture_id}, query: {...this.$route.query}})
        },
        validateContent(){
            var error = 0;
            var content = this.editor.getHTML()
            if(content === null || content === '' || content === '<p></p>'){
                this.errorData = true
                this.errorMsg = `Field Konten tidak boleh kosong`
                error += 1
            }else{
                this.item.message = content
                this.errorData = false
            }
            return error
        },
        async getData() {
            await this.getGuidanceById(this.$route.params.tG_id)
            var response = this.getResponse('tapiGuidance')
            if (response.status == 0) {
                this.showSnackbar ({
                    type: "error",
                    text: response.msg
                })
            }
        },
        async storeData(status = 0) {
            if (this.validateContent() === 0) {
                this.item.status = status
                this.loading = true
                await this.store({id: this.$route.params.tG_id, data: this.item})
                this.loading = false
                var response = this.getResponse('tapiGuidance')
                this.modal = false
                if (response.status == 0) {
                    this.showSnackbar ({
                        type: "error",
                        text: response.msg
                    })
                } else {
                    this.showSnackbar ({
                        type: "success",
                        text: response.msg
                    })
                    this.getData()
                    this.inputType = 'Kirim'
                    this.editor.setContent('')
                }
            } else {
                this.showSnackbar ({
                    type: "error",
                    text: "Data Tidak Boleh Kosong"
                })
            }
        }
    }
}
</script>
